'use strict';

var _ = require('lodash');
var MarketGridsDataService = function MarketGridsDataService(idService, dataRetrieverService, dataRetrieverConstants, flightSearchCriteriaFilterBuilderService, marketGridsUtils, momentService) {
  var GRID_TO_RULES_MAP = {
    'market-demand-analysis': 'marketRules',
    'market-product-group-analysis': 'marketProductRules',
    'service-demand-analysis': 'serviceRules'
  };
  function extractFlowMarkets(associatedServiceClasses) {
    return _.chain(associatedServiceClasses).map(function (id) {
      var parsedServiceId = idService.parseServiceClassId(id);
      return _.first(parsedServiceId).origin + '-' + _.last(parsedServiceId).destination;
    }).uniqWith(_.isEqual).value();
  }
  function getFlowMarkets(demandManagementData) {
    var selectedRowsCabin = demandManagementData.cabinSelectedRows;
    var rules = flightSearchCriteriaFilterBuilderService.buildFilter(selectedRowsCabin);
    return dataRetrieverService.getDataRetriever(dataRetrieverConstants.FLIGHT_SCREEN, dataRetrieverConstants.CABIN_DEEP_MODE).setCustomSearchCriteriaRules(rules).localSortApplied().retrieveComponentData('service-flight-analysis').then(extractFlowMarkets);
  }
  function storeFilter(filterCache, searchRules, filterName) {
    filterCache[filterName] = _.cloneDeep(searchRules[filterName]);
  }
  function isFilterChanged(filterCache, searchRules, filterName) {
    if (filterCache[filterName]) {
      return !marketGridsUtils.searchRulesEqual(searchRules[filterName], filterCache[filterName]);
    } else {
      return true;
    }
  }
  function getPreviewLoaded(previewCache, filterName) {
    if (_.isNil(previewCache[filterName])) {
      setPreviewLoaded(previewCache, filterName, false);
    }
    return previewCache[filterName];
  }
  function setPreviewLoaded(previewCache, filterName, val) {
    previewCache[filterName] = val;
  }
  function prepareMarketDataRetrievers(selected, flowMarkets, demandManagementData) {
    var market = selected.market.split('-');
    var departureDate = demandManagementData.main.departureDate;
    var marketRule = marketGridsUtils.createRule('Mkt Location #0', 'custom:market', '=', flowMarkets);
    var originRule = marketGridsUtils.createRule('Mkt Location #1', 'origin', '=', market[0]);
    var destinationRule = marketGridsUtils.createRule('Mkt Location #2', 'destination', '=', market[1]);
    var date = momentService.copy(departureDate, momentService.TYPE.LOCAL_DATE).startOf('day');
    var departureDateRule = marketGridsUtils.createRule('Date', 'departureDate', '=', date);
    var dateFrom = momentService.copy(departureDate, momentService.TYPE.LOCAL_DATE_TIME).startOf('day');
    var dateTo = momentService.copy(departureDate, momentService.TYPE.LOCAL_DATE_TIME).endOf('day');
    var departureDateService = marketGridsUtils.createRule('Date', 'departureDate', 'Between', dateFrom, dateTo);
    var marketRules = [marketRule, departureDateRule];
    var marketProductRules = [originRule, destinationRule, departureDateRule];
    var serviceRules = [originRule, destinationRule, departureDateService];
    if (!_.isEmpty(selected.poses)) {
      marketProductRules.push(marketGridsUtils.createRule('Mkt Location #3', 'classGroups.posName', '=', selected.poses));
      serviceRules.push(marketGridsUtils.createRule('Mkt Location #3', 'serviceClassPointOfSales.significantPOS', '=', selected.poses));
    }
    if (!_.isEmpty(selected.classGroups)) {
      serviceRules.push(marketGridsUtils.createRule('Product', 'serviceClassPointOfSales.classGroup', '=', selected.classGroups));
    }
    return {
      marketRules: marketRules,
      marketProductRules: marketProductRules,
      serviceRules: serviceRules
    };
  }
  function adjustRules(mode, rules) {
    dataRetrieverService.getDataRetriever('MARKET_SCREEN', mode).setCustomSearchCriteriaRules(rules).resetBrushFilters();
  }
  function resetRules(mode) {
    dataRetrieverService.getDataRetriever('MARKET_SCREEN', mode).resetCustomSearchCriteriaRules().resetBrushFilters();
  }
  function resetDataRetrievers() {
    resetRules('market');
    resetRules('market-product-group');
    resetRules('service');
    resetRules('booking-matrix');
  }
  function adjustDataRetrievers(searchRules) {
    adjustRules('market', searchRules.marketRules);
    adjustRules('market-product-group', searchRules.marketProductRules);
    adjustRules('service', searchRules.serviceRules);
    adjustRules('booking-matrix', searchRules.serviceRules);
  }
  function prepareDataRetrievers(marketGridsParams) {
    var gridId = marketGridsParams.selected.tab;
    var filterName = GRID_TO_RULES_MAP[gridId];
    var searchRules = prepareMarketDataRetrievers(marketGridsParams.selected, marketGridsParams.flowMarkets, marketGridsParams.demandManagementData);
    var filterChanged = isFilterChanged(marketGridsParams.filterCache, searchRules, filterName);
    if (filterChanged) {
      adjustDataRetrievers(searchRules);
      storeFilter(marketGridsParams.filterCache, searchRules, filterName);
    }
    var previewLoaded = getPreviewLoaded(marketGridsParams.previewCache, gridId);
    if (!previewLoaded) {
      setPreviewLoaded(marketGridsParams.previewCache, gridId, true);
    }
    return filterChanged || !previewLoaded;
  }
  function legOptGroupDateKey(c) {
    return c.leg + c.optGroupDateMoment.toString();
  }
  function mapUniq(array, property) {
    return _.chain(array).map(property).uniq().value();
  }
  function rowToManagementData(legCabins) {
    var m = legCabins[0].leg.split('-');
    return {
      origin: m[0],
      destination: m[1],
      departureDate: legCabins[0].legDepartureDateMoment
    };
  }
  function prepareDemandManagementData(selectedRows) {
    var legsDatesSelected = _(selectedRows.cabin).groupBy(legOptGroupDateKey).keys().value();
    var sameLegAndDateSelected = _.size(legsDatesSelected) === 1;
    var legDateSelected = _.first(legsDatesSelected);
    if (!sameLegAndDateSelected) {
      return;
    }
    return {
      main: rowToManagementData(selectedRows.cabin),
      cabinSelectedRows: selectedRows.cabin,
      cabins: mapUniq(selectedRows.cabin, 'cabinCode'),
      classes: mapUniq(selectedRows["class"] ? selectedRows["class"] : [], 'segmentClass'),
      segmentClasses: mapUniq(selectedRows.segment ? selectedRows.segment : [], 'segmentClass'),
      serviceClasses: _.map(selectedRows.service ? selectedRows.service : [], function (s) {
        return _.pick(s, ['className', 'market', 'route']);
      }),
      legDateSelected: legDateSelected
    };
  }
  return {
    getFlowMarkets: getFlowMarkets,
    resetDataRetrievers: resetDataRetrievers,
    prepareDataRetrievers: prepareDataRetrievers,
    prepareDemandManagementData: prepareDemandManagementData
  };
};
MarketGridsDataService.$inject = ['IdService', 'DataRetrieverService', 'DataRetrieverConstantsService', 'FlightSearchCriteriaFilterBuilderService', 'MarketGridsUtilsService', 'MomentService'];
module.exports = MarketGridsDataService;